<template>
<div>
    <section class="container mt-3 mb-5 py-3">
         
        <!-- <px-icon img="user" tam="3" /> -->
        <h4>Iconos</h4>
        <p class="text-dark mt-2 mb-1">Codigo html para añadir iconos SIAHE</p>
        <div class="d-flex">
            <px-icon img="aperturar-mes" class="me-3" />
            <px-icon img="aperturar-mes" color="primary-variant" />
            <px-icon class="mx-3" img="aperturar-mes" color="tertiary-variant" tam="20" />
            <px-icon img="aperturar-mes" color="#08749e" tam="30" />
        </div>
        <div v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup">
    <px-icon img="aperturar-mes" />
    <px-icon img="aperturar-mes" color="primary-variant" />
    <px-icon img="aperturar-mes" color="tertiary-variant" tam="20" />
    <px-icon img="aperturar-mes" color="#08749e" tam="30" />
        </script></code></pre></div>
        <!--  -->
        <table class="table" style="font-size:.8rem;">
            <thead>
                <tr>
                <th scope="col">Propiedad</th>
                <th scope="col">obligatorio</th>
                <th scope="col">Tipo</th>
                <th scope="col">Descripción</th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                <tr v-for="(desc, index) in descripcion" :key="index">
                <th scope="row"> <code>{{desc.propiedad}}</code> </th>
                <td>{{desc.obligatorio}}</td>
                <td>{{desc.tipo}}</td>
                <td>{{desc.descripcion}} </td>
                </tr>
            </tbody>
        </table>



        <!--  -->
   

        <p class="text-dark mt-4 mb-1">listado de titulos de imagenes</p>
   
        <div class="contenedor-card" >
            <div class="card" v-for="(icon, i) in icons" :key="i">
                <div class="card-body pointer d-flex align-items-center" @click="copiarAlPortapapeles(icon.titulo)">
                    <px-icon :img="icon.titulo" color='#303030' />
                </div>
                <div class="card-footer">
                    <code style="font-size:.7rem">{{icon.titulo}}</code>
                </div>
            </div>
            
        </div>


    </section>

</div>
</template>
<script>
import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
export default ({
    name:'PxIcons',
    mixins: [NotificationMixin],
    created(){
        window.scrollTo(0, 0);
    },
    data: function(){
        return {
            descripcion: [
                {'propiedad': 'img', 'obligatorio': 'Si', 'tipo': 'String', 'descripcion': 'Nombre de imagen de icono.'},
                {'propiedad': 'color', 'obligatorio': 'No', 'tipo': 'String', 'descripcion': 'Color que tendra el icono, puede ser de la paleta de colores de SIAHE (ejm: primary), un color el root css (ejm: red), o un hexadecimal (ejm: #08749e)'},
                {'propiedad': 'tam', 'obligatorio': 'No', 'tipo': 'String', 'descripcion': 'Tamaño del icono, numero entero sin especificación de medida, por ejem. 20'}
            ],
            icons: [
                {'id': 1, 'titulo': 'aperturar-mes' },
                {'id': 2, 'titulo': 'adjuntar' },
                {'id': 3, 'titulo': 'claves-pres' },
                {'id': 4, 'titulo': 'aux-contable' },
                {'id': 5, 'titulo': 'bloquear' },
                {'id': 6, 'titulo': 'cancelar' },
                {'id': 7, 'titulo': 'cierre-mes' },
                {'id': 8, 'titulo': 'complementar' },
                {'id': 9, 'titulo': 'consulta' },
                {'id': 10, 'titulo': 'contrapoliza' },
                {'id': 11, 'titulo': 'desbloquear' },
                {'id': 12, 'titulo': 'duplicar' },
                {'id': 13, 'titulo': 'eliminar' },
                {'id': 14, 'titulo': 'enviar-firma' },
                {'id': 15, 'titulo': 'enviar' },
                {'id': 16, 'titulo': 'guardar' },
                {'id': 17, 'titulo': 'modificar' },
                {'id': 18, 'titulo': 'nuevo' },
                {'id': 19, 'titulo': 'precierre-mes' },
                {'id': 20, 'titulo': 'print' },
                {'id': 21, 'titulo': 'procesando' },
                {'id': 22, 'titulo': 'reactivar' },
                {'id': 23, 'titulo': 'rechazar' },
                {'id': 24, 'titulo': 'regresar' },
                {'id': 25, 'titulo': 'salir' },
                {'id': 26, 'titulo': 'validar' },
                {'id': 27, 'titulo': 'usuario' },
                {'id': 28, 'titulo': 'mail' },
                {'id': 29, 'titulo': 'editar1'},
                {'id': 30, 'titulo': 'vinculacion'},
                {'id': 31, 'titulo': 'componentes'},
                {'id': 32, 'titulo': 'actividades'},
                {'id': 33, 'titulo': 'anexoTransversal'},
                {'id': 34, 'titulo': 'igualdadGenero'},
                {'id': 35, 'titulo': 'beneficiarios'},
                {'id': 36, 'titulo': 'presupuestoEtapas'},
                {'id': 37, 'titulo': 'desgloseComponente'},                
            ]
        }
    },
    methods:{
        async copiarAlPortapapeles(texto){
            try {
            const txt = `<px-icon img="${texto}" />`
            await navigator.clipboard.writeText(txt);
            this.openNotification(
                null,
                'success-sh',
                null,
                '¡Copiado!',
                '< px-icon img="'+texto+'" />', 
                '4000' 
            );
           
            // alert('Copied');
            } catch($e) {
           console.log('Cannot copy');
            }
        }

    }

})
</script>
<style lang="scss" scoped>
.contenedor-card{
    display: flex;
    flex-wrap: wrap;
}
.card{ 
    margin: .5rem;
    width: 7rem;
}
.card-body, .card-footer{
    display: flex; 
    justify-content: center;
}

img>svg>path{
    fill:red !important;
}

</style>
